import { render, staticRenderFns } from "./CheckingCollegiateNumber.vue?vue&type=template&id=7247a25e"
import script from "./CheckingCollegiateNumber.vue?vue&type=script&lang=js"
export * from "./CheckingCollegiateNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports